import { render, staticRenderFns } from "./GameBanner.vue?vue&type=template&id=333e84ee&scoped=true"
import script from "./GameBanner.vue?vue&type=script&lang=js"
export * from "./GameBanner.vue?vue&type=script&lang=js"
import style0 from "./GameBanner.vue?vue&type=style&index=0&id=333e84ee&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333e84ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-sea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('333e84ee')) {
      api.createRecord('333e84ee', component.options)
    } else {
      api.reload('333e84ee', component.options)
    }
    module.hot.accept("./GameBanner.vue?vue&type=template&id=333e84ee&scoped=true", function () {
      api.rerender('333e84ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GameBanner.vue"
export default component.exports